import * as moment from 'moment';
import { UserData } from 'src/app/Models/employee-and-user-data';

/** Days before package start when external shore-excursion changes are disabled (view-only). */
export const SHORE_EXCURSION_MODIFICATION_LOCK_DAYS = 10;

/**
 * True from 10 calendar days before package start through the day before embark
 * (view brochure / portal only; external modification links stay off until embark).
 */
export function isShoreExcursionModificationLocked(
  userdata: UserData | undefined,
  now: moment.Moment = moment(),
): boolean {
  if (!userdata) return true;
  const raw = userdata.packagePckgBeg ?? userdata.pckgBeg;
  if (raw == null || raw === '') return false;
  const startDay = moment(moment(raw).format('YYYY-MM-DD')).startOf('day');
  if (!startDay.isValid()) return false;
  const nowDay = moment(now.format('YYYY-MM-DD')).startOf('day');
  const windowStart = startDay
    .clone()
    .subtract(SHORE_EXCURSION_MODIFICATION_LOCK_DAYS, 'days');
  return nowDay.isSameOrAfter(windowStart) && nowDay.isBefore(startDay);
}
